import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import Breadcrumb from '@/components/common/Breadcrumb';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import { useParams } from 'react-router-dom';
import { getByIdOfferService } from '@/services/OfferServices';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import CustomTabs from '@/components/common/CustomTabs';
import InformationTab from './component/InformationTab';
import ImagesTab from './component/ImagesTab';
import ItemsTabs from './component/ItemsTabs';

const OfferViewPage = ({ pageTitle }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [dataSource, setDataSource] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (id && id != '') {
            getDataById(id);
        }
    }, [id]);

    const getDataById = (id) => {
        setIsLoading(true);
        dispatch(getByIdOfferService(id))
            .then((res) => {
                var formData = res?.data?.data;
                setDataSource(formData);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <>
            <Breadcrumb pageTitle={pageTitle} />
            <Card>
                <CardHeader>
                    <h3 className="db-card-title">{pageTitle}</h3>
                </CardHeader>
                <CustomTabs
                    tabsData={[
                        {
                            tabsId: '',
                            title: 'information',
                            icon: 'lab-information',
                            content: <InformationTab dataSource={dataSource} />,
                        },
                        {
                            tabsId: '',
                            title: 'images',
                            icon: 'lab-image',
                            content: <ImagesTab dataSource={dataSource} />,
                        },
                        {
                            tabsId: '',
                            title: 'items',
                            icon: 'lab-variation',
                            content: <ItemsTabs dataSource={dataSource} />,
                        },
                    ]}
                />
            </Card>
        </>
    );
};

export default OfferViewPage;
